/**
 * Centralized Pendo event domain and action constants, plus the shared
 * trackPendo() wrapper for all custom event tracking.
 *
 * Usage with usePendoTracker:
 *   const { trackFeature } = usePendoTracker(PENDO_DOMAINS.MESSAGES);
 *   trackFeature(PENDO_FEATURES.MESSAGES.COMPOSE, PENDO_ACTIONS.OPENED);
 *
 * Usage with trackFeatureEvent directly:
 *   trackFeatureEvent(PENDO_DOMAINS.ALERTS, PENDO_FEATURES.ALERTS.SEND, PENDO_ACTIONS.COMPLETED);
 *
 * Resulting event name: hgs_pwa.<domain>.<feature>.<action>
 *
 * For raw event tracking, use trackPendo() — never call window.pendo.track directly.
 */

export const PENDO_DOMAINS = {
  DASHBOARD: "dashboard",
  MESSAGES: "messages",
  ALERTS: "alerts",
  PEOPLE: "people",
  GROUPS: "groups",
  TEMPLATES: "templates",
  REPORTS: "reports",
  HELP: "help",
  ACCOUNT: "account",
  GUIDE: "guide",
};

export const PENDO_FEATURES = {
  MESSAGES: {
    COMPOSE: "compose",
    THREAD: "thread",
    SEARCH: "search",
    FILTER: "filter",
  },
  ALERTS: {
    SEND: "send",
    SCHEDULE: "schedule",
    TEMPLATE: "template",
    DETAILS: "details",
    EMERGENCY: "emergency",
  },
  PEOPLE: {
    SEARCH: "search",
    FILTER: "filter",
    ADD: "add",
    EDIT: "edit",
    IMPORT: "import",
  },
  GROUPS: {
    CREATE: "create",
    EDIT: "edit",
    MEMBERS: "members",
    MERGE: "merge",
  },
  TEMPLATES: {
    CREATE: "create",
    EDIT: "edit",
    DELETE: "delete",
    PREVIEW: "preview",
  },
  REPORTS: {
    VIEW: "view",
    EXPORT: "export",
    FILTER: "filter",
  },
};

export const PENDO_ACTIONS = {
  OPENED: "opened",
  CLOSED: "closed",
  SUBMITTED: "submitted",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  SEARCHED: "searched",
  FILTERED: "filtered",
  EXPORTED: "exported",
  CLICKED: "clicked",
  VIEWED: "viewed",
  DISMISSED: "dismissed",
  ERROR: "error",
};

// Track pendo errors often happen when the user is not logged in, so we don't want to throw an error in that case. Instead, we just log a warning to the console.
export function trackPendo(eventName, properties = {}) {
  try {
    if (window.pendo && typeof window.pendo.track === "function") {
      window.pendo.track(eventName, {
        ...properties,
        app: "hgs_pwa",
        timestamp: new Date().toISOString(),
      });
    }
  } catch (e) {
    console.warn("[Pendo] Track error", e);
  }
}
